import { getUrlParam } from './utils'
export function getLanguage() {
  let lang = getUrlParam('lang')
  if (lang) {
    return lang.indexOf('en') !== -1 ? 'en' : 'zh'
  }
  return 'zh'
}

export const lang = getUrlParam('_lang') === 'en' || navigator.language.toLowerCase().indexOf('en') >= 0 ? 'en' : 'zh'



// WEBPACK FOOTER //
// ./src/utils/lang.js